export default {
  yes: 'Yes'
}
